import React, { useContext, useEffect, useState } from "react";
import SettingMultiWebContext from "../../../../context/SettingMultiWebContext/SettingMultiWebContext";
import { Button, Col, Form, Modal, ModalBody, ModalHeader } from "reactstrap";
import { WebNavBarMapList } from "../apis/NavApi/NavApi";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { TostMessage } from "../../../utils";
import { alignSection } from "../../../../api/CloneCategoryApi/CloneCategoryApi";

const AlignSectionModal = ({ ByteMiniWeb_Dashboard }) => {
  const {
    cloneAlignModal,
    setCloneAlignModal,
    alignFormData,
    setAlignFormData,
  } = useContext(SettingMultiWebContext);
  const { setLoaderShow } = useContext(LoaderContext);
  const [navMapListData, setNamMapListData] = useState([]);

  const getNavBarMap = async () => {
    try {
      const paramObjForNavMap = {
        showAll: true,
        sortBy: "order",
        sortOrder: "ASC",
      };
      const { data } = await WebNavBarMapList(paramObjForNavMap);
      if (data.status === 200) {
        setNamMapListData(data.payload.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getNavBarMap();
  }, []);

  const emptyData = () => {
    setAlignFormData({
      contentMapId: "",
      navMapId: "",
      order: 0,
      label: "",
    });
    setCloneAlignModal((prev) => {
      return {
        ...prev,
        alignModal: false,
      };
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoaderShow(true);
      const { data } = await alignSection(alignFormData);
      if (data.status === 200) {
        ByteMiniWeb_Dashboard();
        setLoaderShow(false);
        emptyData();
        TostMessage({ message: data, type: "success" });
      }
    } catch (error) {
      setLoaderShow(false);
      TostMessage({ message: error, type: "error" });
    }
  };

  return (
    <Modal size="sm" isOpen={cloneAlignModal.alignModal}>
      <ModalHeader
        toggle={() => {
          emptyData();
        }}
      >
        <span>Align Section</span>
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <Col md="12 mb-2">
            <select
              className="form-select"
              onChange={(e) =>
                setAlignFormData({ ...alignFormData, navMapId: e.target.value })
              }
              value={alignFormData.navMapId}
            >
              <option value="">--Select--</option>
              {navMapListData?.map((navMap) => {
                return (
                  <option value={navMap.navMapId} key={navMap.navMapId}>
                    {navMap?.label || navMap.navbarDetail.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Button style={{ marginTop: "12px" }} type="submit">
            Submit
          </Button>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AlignSectionModal;
